// extracted by mini-css-extract-plugin
export default {"link":"nav__link__qbCOZ"};